module.exports = "<input type=\"file\" (change)=\"onFileSelected($event)\">\n<button (click)=\"uploadFile()\">Upload</button>\n"